import {stage} from '../../../../config/stage';

// flexinet-devops-pipelines-api
const pipelinesAPI = {
    prod: {
        endpoint: 'https://xraaqz5yr5chrpdvzwebrna7ge.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    test: {
        endpoint: 'https://bobaqo3b45gf5a2zchi23mdfne.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    dev: {
        endpoint: 'https://paz4iapu3vf4tikstc3svs3oum.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    ide: {
        endpoint: 'https://paz4iapu3vf4tikstc3svs3oum.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
};

export const appSyncConfig = pipelinesAPI[stage];
